<template>
  <div class="wrapper">
    <div class="content-logo">
      <img src="../image/scan/banner.jpg" alt />
    </div>
    <div class="tracecode-box">{{ portAndTraceCode }}</div>
    <div class="scan-num">
      <div class="scan-box-left">
        <p>扫描次数</p>
        <p>
          <span>{{ count }}</span
          >次
        </p>
        <p>追溯码 {{ code }}</p>
      </div>
      <div class="scan-box-right">
        <div id="qrcode" class="qr-code"></div>
      </div>
    </div>
    <div class="content-details">
      <ul>
        <li>
          <p class="li-label">产品名称</p>
          <p class="li-name">{{ productName }}</p>
        </li>
        <!-- <li>
          <p class="li-label">品牌</p>
          <p class="li-name">{{ specifications }}</p>
        </li> -->
        <li>
          <p class="li-label">品牌</p>
          <p class="li-name">{{ productBrand }}</p>
        </li>
        <li>
          <p class="li-label">质检</p>
          <p class="li-name">
            <span v-if="isQualified" style="color: #2e35ff" @click="certView"
              >合格证</span
            >
          </p>
        </li>
        <li v-for="item in propertyDetailsList" :key="item.id">
          <p class="li-label">{{ item.propertyName }}</p>
          <p class="li-name" v-if="item.propertyType == 4">
            {{ item.propertyValue | dateformat }}
          </p>
          <p class="li-name" v-else>{{ item.propertyValue }}</p>
        </li>
        <li>
          <p class="li-label">工厂</p>
          <p class="li-name">{{ companyName }}</p>
        </li>
        <li v-show="madeDate">
          <p class="li-label">生产日期</p>
          <p class="li-name">{{ madeDate | dateformat }}</p>
        </li>
        <li>
          <p class="li-label">地址</p>
          <p class="li-name">
            <span v-if="provCode">
              {{ provCode | getprov }}
            </span>
            <span v-if="cityCode">
              {{ cityCode | getprov }}
            </span>
            <span v-if="areaCode">
              {{ areaCode | getprov }}
            </span>
            <span> {{ address }}</span>
          </p>
        </li>
        <!-- <li>
          <p class="li-label">网址</p>
          <p class="li-name">{{ website }}</p>
        </li> -->
        <!-- <li>
          <p class="li-label">服务电话</p>
          <p class="li-name">{{}}</p>
        </li> -->
      </ul>
    </div>
    <div class="qrcode-box" v-if="qrcodeImg">
      <img src="../image/scan1/qrcode-bg.png" class="qrcode-bg-img" />
      <div class="qrcode-img-box">
        <img src="../image/scan1/qrcode-box.png" class="qrcode-box-bg" />
        <img :src="qrcodeImg" class="qrcode-img" />
      </div>
      <div class="qrcode-word">
        <p class="qrcode-word1">更多精彩</p>
        <p class="qrcode-word2">扫码关注公众号</p>
      </div>
    </div>
    <div class="other-info-box">
      <ul>
        <li>
          <img
            src="../image/scan0/company-info-icon.png"
            @click="companyTab(1)"
          />
          <p>企业信息</p>
        </li>
        <li>
          <img src="../image/scan0/brand-icon.png" @click="companyTab(2)" />
          <p>品牌推广</p>
        </li>
        <li>
          <img
            src="../image/scan0/trace-code-icon.png"
            @click="companyTab(3)"
          />
          <p>溯源信息</p>
        </li>
      </ul>
    </div>
    <van-popup v-model="show">
      <div class="cert-box">
        <div class="cert-con">
          <div class="cert-title">产品合格证</div>
          <div class="cert-info">
            <div class="cert-li">执行标准：详见外包装</div>
            <div class="cert-li">检验结论：合格</div>
            <div class="cert-li">生产日期/批号：{{ productBatchNum }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
import options from "@/common/province.json";
export default {
  components: {},
  props: {},
  data() {
    return {
      portAndTraceCode:"",
      code: "",
      logo: "",
      companyName: "",
      count: "",
      propertyDeploy: [],
      address: "",
      provCode: "",
      cityCode: "",
      areaCode: "",
      productName: "",
      productBrand: "",
      productTypeName: "",
      productBatchNum: "",
      madeDate: "",
      website: "",
      propertyDetailsList: [],
      specifications: "",
      isQualified: false,
      qrcodeImg: "",
      show: false,
      certImg: "",
      options: options
    };
  },
  watch: {},
  computed: { ...mapState(["codeInfo"]) },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     // 通过 `vm` 访问组件实例
  //     console.log(from);
  //     if (from.path == "/") {
  //       vm.getLocation();
  //     } else {
  //       vm.code = from.params.id;
  //       vm.setPageData(vm.codeInfo);
  //     }
  //   });
  // },
  methods: {
    certView() {
      this.show = true;
    },
    companyTab(id) {
      switch (id) {
        case 1:
          this.$router.push("/scan-companyInfo/" + this.code);
          break;
        case 2:
          this.$router.push("/scan-branding/" + this.code);
          break;
        case 3:
          this.$router.push("/scan-traceability/" + this.code);
          break;
      }
    },
    getUrlParam(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  },
  created() {},
  mounted() {
    (function(win, lib) {
      var doc = win.document;
      var docEl = doc.documentElement;
      var metaEl = doc.querySelector('meta[name="viewport"]');
      var flexibleEl = doc.querySelector('meta[name="flexible"]');
      var dpr = 0;
      var scale = 0;
      var tid;
      var flexible = lib.flexible || (lib.flexible = {});

      if (metaEl) {
        console.warn("将根据已有的meta标签来设置缩放比例");
        var match = metaEl
          .getAttribute("content")
          .match(/initial\-scale=([\d\.]+)/);
        if (match) {
          scale = parseFloat(match[1]);
          dpr = parseInt(1 / scale);
        }
      } else if (flexibleEl) {
        var content = flexibleEl.getAttribute("content");
        if (content) {
          var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
          var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
          if (initialDpr) {
            dpr = parseFloat(initialDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
          if (maximumDpr) {
            dpr = parseFloat(maximumDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
        }
      }

      if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
          // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
          if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
            dpr = 3;
          } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
            dpr = 2;
          } else {
            dpr = 1;
          }
        } else {
          // 其他设备下，仍旧使用1倍的方案
          dpr = 1;
        }
        scale = 1 / dpr;
      }

      docEl.setAttribute("data-dpr", dpr);
      if (!metaEl) {
        metaEl = doc.createElement("meta");
        metaEl.setAttribute("name", "viewport");
        metaEl.setAttribute(
          "content",
          "initial-scale=" +
            scale +
            ", maximum-scale=" +
            scale +
            ", minimum-scale=" +
            scale +
            ", user-scalable=no"
        );
        if (docEl.firstElementChild) {
          docEl.firstElementChild.appendChild(metaEl);
        } else {
          var wrap = doc.createElement("div");
          wrap.appendChild(metaEl);
          doc.write(wrap.innerHTML);
        }
      }

      function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
          width = 540 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + "px";
        flexible.rem = win.rem = rem;
      }

      win.addEventListener(
        "resize",
        function() {
          clearTimeout(tid);
          tid = setTimeout(refreshRem, 300);
        },
        false
      );
      win.addEventListener(
        "pageshow",
        function(e) {
          if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
          }
        },
        false
      );

      if (doc.readyState === "complete") {
        doc.body.style.fontSize = 12 * dpr + "px";
      } else {
        doc.addEventListener(
          "DOMContentLoaded",
          function(e) {
            doc.body.style.fontSize = 12 * dpr + "px";
          },
          false
        );
      }

      refreshRem();

      flexible.dpr = win.dpr = dpr;
      flexible.refreshRem = refreshRem;
      flexible.rem2px = function(d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === "string" && d.match(/rem$/)) {
          val += "px";
        }
        return val;
      };
      flexible.px2rem = function(d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === "string" && d.match(/px$/)) {
          val += "rem";
        }
        return val;
      };
    })(window, window["lib"] || (window["lib"] = {}));

    this.logo = this.codeInfo.companyInfo
      ? this.codeInfo.companyInfo.companyLogo
      : "";
    this.address = this.codeInfo.companyInfo
      ? this.codeInfo.companyInfo.address
      : "";
    this.count = this.codeInfo.tracecodeScanLogVO
      ? this.codeInfo.tracecodeScanLogVO.count
      : 1;
    if (this.codeInfo.productImportLibrary) {
      this.productBatchNum = this.codeInfo.productImportLibrary.productBatchNum;
      this.companyName = this.codeInfo.productImportLibrary.companyName;
      this.madeDate = this.codeInfo.productImportLibrary.madeDate;
      this.provCode = this.codeInfo.productImportLibrary.provCode;
      this.cityCode = this.codeInfo.productImportLibrary.cityCode;
      this.areaCode = this.codeInfo.productImportLibrary.areaCode;
      this.address = this.codeInfo.productImportLibrary.address;
    }
    this.isQualified = this.codeInfo.productImportLibrary ? true : false;
    // this.propertyDeploy = this.codeInfo.propertyDeploy
    //   ? this.codeInfo.propertyDeploy
    //   : [];
    this.productName = this.codeInfo.productionProduct
      ? this.codeInfo.productionProduct.productName
      : "";
    this.productBrand = this.codeInfo.productionProduct
      ? this.codeInfo.productionProduct.productBrand
      : "";
    this.specifications = this.codeInfo.productionProduct
      ? this.codeInfo.productionProduct.specifications
      : "";
    this.propertyDetailsList = this.codeInfo.propertyDetailsList;
    this.website = this.codeInfo.companyInfo
      ? this.codeInfo.companyInfo.companyInfoIntroduction.website
      : "";
    if (
      this.codeInfo.productionProduct &&
      this.codeInfo.productionProduct.productionBrand
    ) {
      this.qrcodeImg = this.codeInfo.productionProduct.productionBrand.productBrandQrCode;
    }
    this.certImg = this.codeInfo.qualifier;
  },
  filters: {
    getprov(code) {
      if (!code) {
        return;
      }
      options.forEach((item, index) => {
        if (code == item.value) {
          code = item.label;
        } else if (item.children.length > 0) {
          item.children.forEach(c => {
            if (code == c.value) {
              code = c.label;
            } else {
              if (c.children.length > 0) {
                c.children.forEach(cc => {
                  if (code == cc.value) {
                    code = cc.label;
                  }
                });
              }
            }
          });
        }
      });
      return code;
    }
  }
};
</script>
<style lang="less" scoped>
@base: 40;

.wrapper {
  html {
    font-size: 20px;
  }
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  background-color: #ffffff;
  .content-logo {
    width: 100%;
      img {
        width: 100%;
        height: auto;
      }
    .company-name {
      font-size: 1rem / @base * 16;
      text-align: center;
      width: 80%;
      margin: 0 auto;
      color: #b0823b;
    }
  }
  .scan-num {
    width: 90%;
    margin: 5%;
    border-radius: 0.5rem;
    box-shadow: 0 0 10px #e0e0e0;
    padding: 20rem / @base 0;
    display: flex;
    .scan-box-left,
    .scan-box-right {
      width: 50%;
      display: inline-block;
      vertical-align: top;
    }
    .scan-box-left {
      p {
        padding-left: 30rem / @base;
        color: #60605f;
        font-size: 1rem / @base * 14;
        margin-bottom: 15px;
        span {
          font-size: 1rem / @base * 30;
          color: #cd9e5c;
          margin-right: 5px;
          font-weight: bold;
        }
      }
      p:nth-child(3) {
        margin-bottom: 0;
      }
    }
    .scan-box-right {
      .qr-code {
        text-align: center;
        /deep/img {
          display: inline-block !important;
        }
      }
    }
  }
  .content-details {
    ul {
      width: 80%;
      margin: 0 auto;
      li {
        display: flex;
        width: 100%;
        margin-top: 20px;
        .li-label {
          width: 80px;
          font-size: 1rem / @base * 15;
          color: #60605f;
        }
        .li-name {
          width: calc(100% - 100px);
          text-align: right;
          font-size: 1rem / @base * 16;
          color: #343434;
          word-break: break-word;
        }
      }
    }
  }
  .advice {
    width: 80%;
    margin: 0 auto;
    margin-top: 10px;
    color: red;
  }
  .qrcode-box {
    position: relative;
    margin-top: 20rem / @base;
    .qrcode-bg-img {
      width: 100%;
      height: 5rem / @base * 22;
    }
    .qrcode-img-box {
      position: absolute;
      bottom: 0;
      left: 5%;
      width: 5rem / @base * 30;
      height: 5rem / @base * 20;
      .qrcode-box-bg {
        height: 100%;
        width: 100%;
      }
      .qrcode-img {
        position: absolute;
        bottom: 5rem / @base * 2;
        left: calc(5% + 5rem / @base * 6);
        height: 5rem / @base * 17;
      }
    }
    .qrcode-word {
      position: absolute;
      left: calc(10% + 5rem / @base * 30);
      top: 50%;
      transform: translateY(-50%);
      .qrcode-word1 {
        font-size: 10rem / @base * 2;
        font-weight: bold;
        color: #e92d23;
        text-shadow: 2px 2px 0px #ffffff;
      }
      .qrcode-word2 {
        margin-top: 8rem / @base;
        font-size: 12rem / @base * 2;
        font-weight: bold;
        color: #e92d23;
        text-shadow: 2px 2px 0px #ffffff;
      }
    }
  }
  .other-info-box {
    width: 100%;
    margin: 0 auto;
    ul {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      margin-bottom: 50px;
      li {
        padding: 20rem / @base 0;
        text-align: center;
        width: 30%;
        border-radius: 12rem / @base;
        background-color: #fbf7f3;
        p {
          font-size: 1rem / @base * 17;
          margin-top: 10px;
          color: #b0823b;
        }
        img {
          width: 70%;
        }
      }
    }
  }

  .content {
    margin-top: 8rem / @base;
    .logo {
      width: 100%;
      text-align: center;
      background-color: #fff;
      img {
        width: 50%;
      }
    }
    .info {
      margin-top: 8rem / @base;
      background-color: #fff;
      padding-left: 35rem / @base;
      .l1 {
        padding: 20rem / @base 0 0;
        display: flex;
        align-items: baseline;
        &:last-child {
          padding-bottom: 20rem / @base;
        }
        span {
          color: #343434;
          font-size: 1rem / @base * 16;
        }
        .s1 {
          width: 31%;
          text-align: left;
        }
        .btn {
          width: 150rem / @base;
          height: 50rem / @base;
          background-image: url("../image/scan/btnbg.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          text-align: center;
          color: #fff;
          line-height: 40rem / @base;
        }
      }
    }
    .productInfo {
      margin-top: 8rem / @base;
      background-color: #fff;
      padding: 0 30rem / @base 0 30rem / @base;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12rem / @base 0;
        border-bottom: 1px solid #f1f1f1;
        font-size: 1rem / @base * 15 !important;
        .left {
          display: flex;
          align-items: center;
          .line {
            height: 30rem / @base;
            width: 5rem / @base;
            background-color: #1375d2;
            margin-right: 6rem / @base;
          }
          .text {
            font-size: 1rem / @base * 18;
          }
        }
        .right {
          img {
            width: 20rem / @base;
            height: 20rem / @base;
            transform: rotate(0deg);
            transition: transform 0.5s;
          }
          .active {
            transform: rotate(180deg);
            transition: transform 0.5s;
          }
        }
      }
      .box {
        .companyInfo {
          line-height: 1rem / @base * 24;
          padding: 10rem / @base 0;
        }
        .l1 {
          padding: 20rem / @base 0 0;
          display: flex;
          align-items: baseline;
          &:last-child {
            padding-bottom: 20rem / @base;
          }
          span {
            color: #343434;
            font-size: 1rem / @base * 16;
          }
          .s1 {
            width: 31%;
            text-align: left;
          }
          .index {
            width: 100%;
            font-size: 1rem / @base * 18;
            font-weight: bold;
            color: #1375d2;
            border-bottom: 1px solid #f1f1f1;
            padding: 15rem / @base 0;
          }
          .activeIndex {
            border-top: 1px solid #f1f1f1;
          }
        }
        .textwrap {
          .image {
            width: 60%;
            display: block;
            margin: 20rem / @base auto;
          }
          .text {
            line-height: 1rem / @base * 24;
            text-indent: 2em;
            padding-bottom: 10rem / @base;
            font-size: 1rem / @base * 15 !important;
          }
        }
      }
    }
  }
  .nohave {
    padding: 0 1rem / @base * 15;
    .title {
      font-size: 1rem / @base * 22;
    }
    .info {
      margin-top: 1rem / @base * 20;
      display: flex;
      .image {
        width: 1rem / @base * 40;
        height: 1rem / @base * 40;
        margin-right: 1rem / @base * 30;
        img {
          width: 100%;
        }
      }
      .code {
        p {
          color: red;
          font-size: 1rem / @base * 16;
          margin-bottom: 1rem / @base * 15;
        }
        .line {
          width: 100%;
          height: 1px;
          border: 1px solid #eee;
        }
        .tishi {
          margin-top: 1rem / @base * 15;
          color: royalblue;
          font-size: 1rem / @base * 16;
        }
      }
    }
  }
  .footer {
    text-align: left;
    padding: 10rem / @base 0;
    display: inline-block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    .text1 {
      font-size: 1rem / @base * 12;
      color: #004281;
      .footer-label {
        .title-top {
          vertical-align: top;
          width: 1rem / @base * 75;
        }
        p {
          vertical-align: top;
          font-size: 1rem / @base * 15;
        }
        div {
          vertical-align: top;
          font-size: 1rem / @base * 15;
          display: inline-block;
        }
      }
    }
    .text2 {
      font-size: 1rem / @base * 12;
      .footer-label {
        .title-top {
          width: 1rem / @base * 75;
          vertical-align: top;
        }
        p {
          vertical-align: top;
          font-size: 1rem / @base * 15;
        }
        div {
          vertical-align: top;
          font-size: 1rem / @base * 15;
          display: inline-block;
        }
      }
    }
  }
  .cert-box {
    height: 28rem / @base * 8;
    width: 40rem / @base * 8;
    .cert-con {
      width: 80%;
      height: 80%;
      margin: calc(16%) calc(10% - 3px) calc(10% - 3px);
      border: solid 3px #9e9f9f;
      border-radius: 10px;
      position: relative;
      .cert-title {
        font-size: 21rem / @base;
        font-weight: bold;
        height: 20rem / @base * 2;
        background-color: #009944;
        border-radius: 20rem / @base;
        width: 40rem / @base * 4;
        color: #ffffff;
        line-height: 20rem / @base * 2;
        text-align: center;
        position: absolute;
        left: 50%;
        top: -20rem / @base;
        transform: translateX(-50%);
      }
      .cert-info {
        margin-top: 20rem / @base * 2;
        .cert-li {
          margin-top: 10rem / @base * 2;
          font-size: 16rem / @base;
          width: 90%;
          margin-left: 5%;
          padding-bottom: 5px;
          border-bottom: 2px solid #9e9f9f;
        }
      }
    }
  }
  .maskInfo {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    overflow-y: auto;
    z-index: 100;
    .close {
      width: 1rem / @base * 40;
      height: 1rem / @base * 40;
      line-height: 1rem / @base * 40;
      text-align: center;
      position: absolute;
      right: 24rem / @base;
      top: 0;
      color: #343434;
      img {
        width: 2rem / @base * 8;
      }
    }
    .textwrap {
      width: 80%;
      position: absolute;
      top: 10%;
      left: 0;
      right: 0;
      margin: auto;
      background: #fff;
      padding: 20rem / @base;
      border-radius: 15rem / @base;
      margin-bottom: 25rem / @base;
      div {
        line-height: 1rem / @base * 32;
        text-indent: 2em;
        font-size: 1rem / @base * 18;
        text-align: justify;
      }
    }
  }
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    #biao1 {
      color: #38adff;
    }
    .cdkey {
      width: 70%;
      height: 1rem / @base * 240;
      position: absolute;
      top: 20%;
      left: 0;
      right: 0;
      margin: auto;
      background: #fff;
      padding: 1rem / @base * 10;
      .title {
        font-size: 1rem / @base * 18;
        color: red;
      }
      p {
        margin-bottom: 1rem / @base * 20;
        span {
          color: red;
        }
      }
      .el-button {
        float: right;
      }
      .close {
        width: 1rem / @base * 40;
        height: 1rem / @base * 40;
        line-height: 1rem / @base * 40;
        text-align: center;
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}
.wmassageMask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 101;
  display: flex;
  justify-content: center;
  .messageMaskContent {
    position: absolute;
    top: 20%;
    width: 85%;
  }
  .cash_bonus_title {
    position: absolute;
    top: 25%;
    color: #fddeab;
    text-align: center;
    p {
      font-size: 1rem / @base * 18;
    }
    .cash_mount {
      font-size: 1rem / @base * 36;
      font-weight: bolder;
      margin-top: 7.5rem / @base;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/scan1.vue